import { render, staticRenderFns } from "./SVGSection.vue?vue&type=template&id=04ff9c63&scoped=true"
import script from "./SVGSection.vue?vue&type=script&lang=js"
export * from "./SVGSection.vue?vue&type=script&lang=js"
import style0 from "./SVGSection.vue?vue&type=style&index=0&id=04ff9c63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ff9c63",
  null
  
)

export default component.exports